import React from 'react';
import { RatingWidget } from '../RatingComponents';

interface RatingModalProps {
  isOpen: boolean;
  onClose: () => void;
  errandId: string;
  rateeId: string;
  rateeName: string;
  ratingType: 'customer_to_driver' | 'driver_to_customer';
  onRatingSubmitted?: () => void;
}

const RatingModal: React.FC<RatingModalProps> = ({
  isOpen,
  onClose,
  errandId,
  rateeId,
  rateeName,
  ratingType,
  onRatingSubmitted
}) => {
  if (!isOpen) return null;

  const handleRatingSubmitted = () => {
    onRatingSubmitted?.();
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        {/* The RatingWidget now controls the entire content */}
        <RatingWidget
            errandId={errandId}
            rateeId={rateeId}
            rateeName={rateeName}
            ratingType={ratingType}
            onRatingSubmitted={handleRatingSubmitted}
        />
        <div className="p-4 text-center">
            <button
              type="button"
              onClick={onClose}
              className="w-full px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors"
            >
              Close
            </button>
        </div>
      </div>
    </div>
  );
};

export default RatingModal;



